import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';

export default styled(CircularProgress)``;
